import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import StylishDynamicTabs from '../../../../components/StylishDynamicTabs';
import AppCard from '../../../../components/cards/AppCard';
import {
  getPipelineCount,
  getShortlistedCount,
  getSubmittedCandidates,
} from '../../../../services/dropdownApi';
import SourcingTab from './SourcingTab';
import PipelineTab from './PipelineTab';
import ShortlistedTab from './ShortlistedTab';
import SubmittedTab from './SubmittedTab';

export default function CandidatesTab({ jobId, onDescriptionSaved }) {
  // The active sub-tab is driven by the `?subTab=` URL param so it can be
  // deep-linked directly (e.g. /jobs/:id?tab=candidates&subTab=pipeline).
  const [searchParams, setSearchParams] = useSearchParams();
  const activeSubTab = searchParams.get('subTab') || 'source';
  const setActiveSubTab = (key) => {
    const next = new URLSearchParams(searchParams);
    next.set('subTab', key);
    setSearchParams(next, { replace: true });
  };
  const [pipelineCount, setPipelineCount]     = useState(null);
  const [shortlistedCount, setShortlistedCount] = useState(null);
  const [submittedCount, setSubmittedCount] = useState(null);

  const fetchCounts = () => {
    if (!jobId) return;
    getPipelineCount({ jobId }).then(setPipelineCount).catch(() => {});
    getShortlistedCount({ jobId }).then(setShortlistedCount).catch(() => {});
    getSubmittedCandidates(jobId)
      .then((data) => setSubmittedCount(Array.isArray(data) ? data.length : 0))
      .catch(() => {});
  };

  useEffect(() => { fetchCounts(); }, [jobId]);

  const tabs = [
    { key: 'source',      label: 'Source' },
    { key: 'pipeline',    label: 'Pipeline',    count: pipelineCount },
    { key: 'shortlisted', label: 'Shortlisted', count: shortlistedCount },
    { key: 'submitted',   label: 'Submitted',   count: submittedCount },
  ];

  return (
    <div className="candidates-tab-wrapper">
      <AppCard>
        <StylishDynamicTabs
          tabs={tabs}
          activeKey={activeSubTab}
          onChange={setActiveSubTab}
        />
      </AppCard>

      {activeSubTab === 'source'      && <SourcingTab    jobId={jobId} onActionComplete={fetchCounts} onDescriptionSaved={onDescriptionSaved} />}
      {activeSubTab === 'pipeline'    && <PipelineTab    jobId={jobId} onCountChange={setPipelineCount} />}
      {activeSubTab === 'shortlisted' && <ShortlistedTab jobId={jobId} onCountChange={setShortlistedCount} />}
      {activeSubTab === 'submitted'   && <SubmittedTab   jobId={jobId} onCountChange={setSubmittedCount} />}
    </div>
  );
}
